import { render, staticRenderFns } from "./政策法规详情.vue?vue&type=template&id=3d851c57&scoped=true"
import script from "./政策法规详情.vue?vue&type=script&lang=js"
export * from "./政策法规详情.vue?vue&type=script&lang=js"
import style0 from "./政策法规详情.vue?vue&type=style&index=0&id=3d851c57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d851c57",
  null
  
)

export default component.exports